const HAS_FETCH_SUPPORT = "fetch" in self;

const getIsFetchSupported = () => HAS_FETCH_SUPPORT;

export {
	getIsFetchSupported,
};
